export default function isStringNullOrEmpty(input: string | null | undefined): boolean {
	return input === null || input === "" || input === undefined;
}
